import { Link } from "react-router-dom";
import { SartellLogo } from "../apps/availability/components/Logo";

/* The platform landing page: pick which Sartell Soccer app you want.
   Adding an app = adding an entry here plus a route in src/App.jsx. */
const APPS = [
  {
    to: "/availability",
    name: "Availability",
    blurb: "Tell your coach which days your player can't make it.",
  },
  {
    to: "/gear",
    name: "Gear Exchange",
    blurb: "Buy and sell used soccer gear with other SSA families.",
  },
];

export function AppLauncher() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-sky-50 to-white">
      <div className="max-w-3xl mx-auto px-4 py-10 sm:py-16">
        {/* subtitle={null} — the crest and "Sartell Soccer" front the whole
            platform here; naming one of the apps at the top would be wrong. */}
        <div className="flex flex-col items-center text-center">
          <SartellLogo size="lg" subtitle={null} />
          <p className="mt-4 text-gray-500">Choose an app to get started.</p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          {APPS.map((app) => (
            <Link
              key={app.to}
              to={app.to}
              className="group block rounded-2xl bg-white border border-slate-200 p-6 shadow-sm
                         hover:shadow-md hover:border-blue-300 focus:outline-none focus:ring-2
                         focus:ring-blue-500 transition"
            >
              <h2 className="text-lg font-semibold text-gray-800 group-hover:text-blue-700">
                {app.name}
              </h2>
              <p className="mt-1 text-sm text-gray-500">{app.blurb}</p>
              <span className="mt-3 inline-block text-sm font-semibold text-blue-600">
                Open →
              </span>
            </Link>
          ))}
        </div>

        <p className="mt-10 text-center text-sm">
          <Link to="/help" className="font-semibold text-blue-600 hover:text-blue-800">
            Help
          </Link>
        </p>
        <p className="mt-2 text-center text-xs text-gray-400">
          Sartell Soccer Association
        </p>
      </div>
    </div>
  );
}
